/**
 * Retrieves a section using the Section Rendering API
 *
 * @param {String} url - URL of the section to return
 * @returns HTMLElement
 */

export const fetchSection = (url) =>
    fetch(url)
      .then((res) => res.text())
      .then((html) =>
        new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(".shopify-section")
      );

class MatchingProducts extends HTMLElement {
  constructor() {
    super();

    this.drawerMatchingProducts = document.querySelector('drawer-matching-products');
  }

  connectedCallback() {
    this.fetchCall()

    document.addEventListener('matching-products:add', () => {
      this.fetchCall();
    })
  }

  loadingState(element, isLoading) {
    if (isLoading == true) {
      setTimeout(() => {
        element.classList.add('loading');
      }, '4000');
    }
    else {
      setTimeout(() => {
        element.classList.remove('loading');
      }, '4000');
    }
  }

  fetchCall() {
    this.productId = this.dataset.productId;
    const recommendationIntent = this.dataset.recommendationsIntent;
    let url = window.Shopify.routes.root + `recommendations/products?product_id=${this.productId}&limit=4&section_id=drawer-matching-products&intent=${recommendationIntent}`;
    const matchingProducts = this.querySelector('[data-matching-products]');

    fetchSection(url).then((section) => {
      if (section && section.innerHTML.trim() && recommendationIntent == 'complementary') {
        matchingProducts.innerHTML = section.innerHTML;
        this.loadingState(this.drawerMatchingProducts, false);
        document.querySelectorAll('[data-drawer-trigger]').forEach(drawerTrigger => {
          if (drawerTrigger.getAttribute('data-drawer-trigger') == this.dataset.productPanel) {
            drawerTrigger.parentNode.previousElementSibling.classList.remove('hidden');
            drawerTrigger.parentNode.classList.remove('hidden');
          }
        });
      } 
      else {
        document.querySelectorAll('[data-drawer-trigger]').forEach(drawerTrigger => {
          if (drawerTrigger.getAttribute('data-drawer-trigger') == this.dataset.productPanel) {
            drawerTrigger.parentNode.classList.add('hidden');
          }
        });
      }
    });
  }
}

customElements.define('matching-products', MatchingProducts);